import script from "./InstructionEasyBusyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionEasyBusyPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionEasyBusyPage.vue?vue&type=style&index=0&id=e8edf19e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8edf19e"]])

export default __exports__